import React from "react";
import "./card-style.css";

const CardVideo = ({ source, type }) => <div className="card">
    <video controls autoPlay loop muted className="card-content">
        <source src={source} type={type}/>
    </video>
</div>

export default CardVideo;